import React from "react";
import classNames from "classnames";
import {observer} from "mobx-react";
import {OrbitComponent} from "../../../../../base-components/orbit-component/orbit-component";
import {FilterButtonBox} from "../../boxes/filter-button/filter-button.box";
import {ACTIVE} from "../../../../../../themes/css-global-classes";
import {LiveCasinoArenaNavbarButtonProps} from "../../../../../arena-host/new-live-casino-arena/live-casino-arena-navbar/live-casino-arena-navbar-button.component";
import {Link} from "../../../../../raw-components/link/link";
import {LiveCasinoArenaNavbarButtonWrapperBox} from "../../../../../arena-host/new-live-casino-arena/live-casino-arena-navbar/boxes/live-casino-arena-navbar-button/wrapper/live-casino-arena-navbar-button-wrapper.box";


export const MiniOrbitLiveCasinoFilterButton = observer(
  class MiniOrbitLiveCasinoFilterButton extends OrbitComponent<LiveCasinoArenaNavbarButtonProps> {

    onFilterClicked(isActive: boolean) {
      if(!isActive) {
        this.services.analytics.sendOrbitUserFlowEvent("Navigation","Live Tab", this.props.labelTranslationKey);
        this.props && this.props.onClick();
      }
    }

    render() {
      return (
        <LiveCasinoArenaNavbarButtonWrapperBox>
            <Link box={FilterButtonBox}
              href={this.props.seoPage}
              onClick={()=> this.onFilterClicked(this.props.isActiveTab)}
              className={classNames({[ACTIVE]: this.props.isActiveTab})}>
              {this.services.translation.translate(this.props.labelTranslationKey).toUpperCase()}
            </Link>
        </LiveCasinoArenaNavbarButtonWrapperBox>
      );
    }
  }
);
